import { render, staticRenderFns } from "./StudentConfirmForm.vue?vue&type=template&id=6b286176&scoped=true"
import script from "./StudentConfirmForm.vue?vue&type=script&lang=ts"
export * from "./StudentConfirmForm.vue?vue&type=script&lang=ts"
import style0 from "./StudentConfirmForm.vue?vue&type=style&index=0&id=6b286176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b286176",
  null
  
)

export default component.exports